/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Related_AllInputs */

const en_project_related_all = /** @type {(inputs: Project_Related_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All projects`)
};

const lv_project_related_all = /** @type {(inputs: Project_Related_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi darbi`)
};

/**
* | output |
* | --- |
* | "All projects" |
*
* @param {Project_Related_AllInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_related_all = /** @type {((inputs?: Project_Related_AllInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Related_AllInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_related_all(inputs)
	return en_project_related_all(inputs)
});